import { RequestService } from '../../../../common/services/RequestService';
import { API_PROFILE } from '../../../Authorization/api/constants';

export const getProfileButtonsRequest = payload => {
  return RequestService.get(API_PROFILE + '/' + payload + '/buttons').then(
    response => response
  );
};
